export const GET_INTERVIEWS = "GET_INTERVIEWS"
export const GET_INTERVIEWS_SUCCESSFULL = "GET_INTERVIEWS_SUCCESSFULL"
export const GET_INTERVIEWS_FAILED = "GET_INTERVIEWS_FAILED"
export const GET_ALL_INTERVIEWS = "GET_ALL_INTERVIEWS"
export const GET_ALL_INTERVIEWS_SUCCESSFULL = "GET_ALL_INTERVIEWS_SUCCESSFULL"
export const GET_CANDIDATE_SCREENING_DATA="GET_CANDIDATE_SCREEN_DATA"
export const GET_CANDIDATE_SCREENING_DATA_SUCCESSFULL="GET_CANDIDATE_SCREENING_DATA_SUCCESSFULL"
export const GET_CANDIDATE_SCREEN_DATA_FAILED="GET_CANDIDATE_SCREEN_DATA_FAILED"
export const UPDATE_SCREENED_CANDIDATE_DETAILS="UPDATE_SCREENED_CANDIDATE_DETAILS"
export const UPDATE_SCREENED_CANDIDATE_DETAILS_SUCCESS="UPDATE_SCREENED_CANDIDATE_DETAILS_SUCCESS"
export const UPDATE_SCREENED_CANDIDATE_DETAILS_FAILED="UPDATE_SCREENED_CANDIDATE_DETAILS_FAILED"
export const GET_SHORTLIST_MANAGERS_LIST="GET_SHORTLIST_MANAGERS_LIST"
export const GET_SHORTLIST_MANAGERS_LIST_SUCCESS="GET_SHORTLIST_MANAGERS_LIST_SUCCESS"
export const GET_SHORTLIST_MANAGERS_LIST_FAILED="GET_SHORTLIST_MANAGERS_LIST_FAILED"
export const ADD_SHORTLIST_MANAGER="ADD_SHORT_LIST_MANAGER"
export const ADD_SHORTLIST_MANAGER_SUCCESS="ADD_SHORTLIST_MANAGER_SUCCESS"
export const ADD_SHORTLIST_MANAGER_FAILURE="ADD_SHORTLIST_MANAGER_FAILURE"
export const MOVE_TO_SHORTLIST="MOVE_TO_SHORTLIST"
export const MOVE_TO_SHORTLIST_SUCCESS="MOVE_TO_SHORTLIST_SUCCESS"
export const MOVE_TO_SHORTLIST_FAILED="MOVE_TO_SHORTLIST_FAILED"
export const GET_SHORTLIST_CANDIDATE_DATA="GET_SHORTLIST_CANDIDATE_DATA"
export const GET_SHORTLIST_CANDIDATE_DATA_SUCCESS="GET_SHORTLIST_CANDIDATE_DATA_SUCCESS"
export const GET_SHORTLIST_CANDIDATE_DATA_FAILED="GET_SHORTLIST_CANDIDATE_DATA_FAILED"
export const UPDATE_SHORTLIST_CANDIDATE_DETAILS="UPDATE_SHORTLIST_CANDIDATE_DETAILS"
export const UPDATE_SHORTLIST_CANDIDATE_DETAILS_SUCCESS="UPDATE_SHORTLIST_CANDIDATE_DETAILS_SUCCESS"
export const UPDATE_SHORTLIST_CANDIDATE_DETAILS_FAILED="UPDATE_SHORTLIST_CANDIDATE_DETAILS_FAILED"
export const RECRUITMENT_CANDIDATE_DETAIL="RECRUITMENT_CANDIDATE_DETAIL"
export const RECRUITMENT_CANDIDATE_DETAIL_SUCCESS="RECRUITMENT_CANDIDATE_DETAIL_SUCCESS"
export const RECRUITMENT_CANDIDATE_DETAIL_FAILED="RECRUITMENT_CANDIDATE_DETAIL_FAILED"
export const SHOW_OFFER_LETTER="SHOW_OFFER_LETTER"
export const SHOW_OFFER_LETTER_SUCCESS="SHOW_OFFER_LETTER_SUCCESS"
export const SHOW_OFFER_LETTER_FAILED="SHOW_OFFER_LETTER_FAILED"
export const DELETE_INTERVIEW='DELETE_INTERVIEW'
export const DELETE_INTERVIEW_SUCCESS="DELETE_INTERVIEW_SUCCESS"
export const DELETE_INTERVIEW_ERROR="DELETE_INTERVIEW_ERROR"